import React, { memo, useCallback, useMemo } from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import LicenseContent from 'Pods/SearchPage/Shared/LicenseContent/LicenseContent'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { clearLicenses } from 'Pods/SearchPage/Store/actions/licenses'
import { LICENSE_TYPE } from 'Pods/SearchPage/Store/constants'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'
import FiltersWrapper from 'Pods/Shared/FiltersWrapper/FiltersWrapper'


function License() {
  const translate = useTranslate()

  const licenses = useSearchPageStore(state => state.licenses)
  const aiUsageAllowed = useSearchPageStore(state => state.aiUsageAllowed)

  const hasSelectedAnyFilter = useMemo(() => {
    return licenses[0] !== LICENSE_TYPE.ALL || aiUsageAllowed
  }, [licenses, aiUsageAllowed])

  const handleReset = useCallback(() => {
    clearLicenses()
  }, [])

  const content = useMemo(() => (
    <>
      <LicenseContent />
      <Button
        type="ghost"
        size="tiny"
        customClass="filter-wrapper__reset-button"
        onClick={handleReset}
        disabled={!hasSelectedAnyFilter}
      >
        {translate('search_page.filters.more_filters.reset')}
      </Button>
    </>
  ), [handleReset, hasSelectedAnyFilter, translate])

  return (
    <FiltersWrapper
      trailIconSize="small"
      placeholder={translate('search_page.filters.license.title')}
      content={content}
      hasSelectedAnyFilters={hasSelectedAnyFilter}
      closingDropdownClassName="filter-wrapper"
    />
  )
}

export default memo(License)
